import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/Datepicker/index.jsx";
import React, { useState, useMemo, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { parseISO, format } from 'date-fns';
import de from 'date-fns/locale/de';
import PropTypes from 'prop-types';
import { inputDefaultProps, inputPropTypes } from '../../../commonProps';
import Label from '../../structure/Label';
import FormRow from '../../structure/FormRow';
import FormHint from '../../structure/FormHint';
registerLocale('de', de);
function DatepickerComponent(props) {
  var id = props.id,
    value = props.value,
    name = props.name,
    children = props.children,
    labelClass = props.labelClass,
    inputClass = props.inputClass,
    errorClass = props.errorClass,
    rowClass = props.rowClass,
    disabled = props.disabled,
    onChange = props.onChange,
    errors = props.errors,
    warning = props.warning,
    info = props.info,
    displayFormat = props.displayFormat,
    outputFormat = props.outputFormat,
    locale = props.locale,
    placeholder = props.placeholder,
    filterDate = props.filterDate,
    datepickerOptions = props.datepickerOptions,
    showYearDropdown = props.showYearDropdown;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    inputDate = _useState2[0],
    setInputDate = _useState2[1];
  var hasErrors = useMemo(function () {
    return errors && Object.hasOwnProperty.call(errors, name);
  }, [errors, name]);
  var errorMessage = useMemo(function () {
    if (hasErrors) {
      return errors[name].message;
    }
    return null;
  }, [errors, name, hasErrors]);
  useEffect(function () {
    if (inputDate instanceof Date && !Number.isNaN(inputDate)) {
      onChange(format(inputDate, outputFormat));
      return;
    }
    onChange('');
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [inputDate, outputFormat]);
  useEffect(function () {
    var dateValue = '';
    if (value instanceof Date && !Number.isNaN(value)) {
      dateValue = value;
    }
    if (value && typeof value) {
      dateValue = parseISO(value);
    }
    if (inputDate !== value && dateValue) {
      setInputDate(dateValue);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [value]);
  var inputClassName = hasErrors ? "".concat(inputClass, " ").concat(errorClass) : inputClass;
  return /*#__PURE__*/React.createElement(FormRow, {
    className: rowClass,
    hasErrors: hasErrors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-section-compact__row",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Label, {
    id: "".concat(id, "-label"),
    className: labelClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 17
    }
  }, children), /*#__PURE__*/React.createElement(DatePicker, Object.assign({
    wrapperClassName: "datepicker",
    className: inputClassName,
    selected: inputDate,
    onChange: function onChange(date) {
      return setInputDate(date);
    },
    dateFormatCalendar: "LLLL yyyy",
    dateFormat: displayFormat,
    locale: locale,
    showYearDropdown: showYearDropdown,
    ariaLabelledBy: "".concat(id, "-label"),
    disabled: disabled,
    id: id,
    name: name,
    placeholderText: placeholder,
    filterDate: filterDate
  }, datepickerOptions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 13
    }
  }));
}
export default function Datepicker(props) {
  var _this = this;
  /* eslint-disable-next-line react/prop-types */
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: ""
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        value = _ref.value;
      return /*#__PURE__*/React.createElement(DatepickerComponent, Object.assign({}, props, {
        onChange: onChange,
        onBlur: onBlur,
        value: value || '',
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 17
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }));
}
DatepickerComponent.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  displayFormat: PropTypes.string,
  outputFormat: PropTypes.string,
  locale: PropTypes.string,
  filterDate: PropTypes.func,
  datepickerOptions: PropTypes.object,
  showYearDropdown: PropTypes.bool
});
DatepickerComponent.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  inputClass: 'form-element form-element--large form-element--datepicker',
  displayFormat: 'dd.MM.yyyy',
  outputFormat: 'yyyy-MM-dd',
  locale: 'de',
  filterDate: undefined,
  datepickerOptions: {},
  showYearDropdown: true
});